import React, { useRef } from "react";

const Scroller = props => {

  const videoPlayer = useRef(null);

  const handlePlayback = _ => {
    if (videoPlayer.current.paused) {
      videoPlayer.current.play();
    }
    else {
      videoPlayer.current.pause();
    }
  }

  return (
    <>
      <section className="scroller">
        <div className="video">
          <video ref={videoPlayer} onClick={handlePlayback} autoPlay loop playsInline muted controlsList="noremoteplayback">
            <source src={`img/projects/${props.work.slug}/scroller/scroller.webm`} type="video/webm" />
            <source src={`img/projects/${props.work.slug}/scroller/scroller.mp4`} type="video/mp4" />
          </video>
        </div>
        <figcaption><p>{props.work.focus.scroller}</p></figcaption>
      </section>
    </>
  )
}

export default Scroller;